import { Controller } from "@hotwired/stimulus"

// Generyczny checkbox z zapisem do bazy bez wchodzenia w edycję.
// Po zmianie wysyła request (domyślnie PATCH) na `urlValue` z body `{ value: checked }`,
// w trakcie zapisu pokazuje spinner w elemencie `.intum-field-status` (zarezerwowane
// miejsce w partialu — bez przesuwania layoutu). Po sukcesie pokazuje zielony check,
// przy błędzie cofa stan checkboxa i pokazuje czerwony krzyżyk.
//
// Endpoint może użyć przesłanego `value` (tryb deklaratywny) albo go zignorować
// i sam przełączyć flagę (tryb toggle) — komponent jest agnostyczny.
//
// Użycie (patrz app/views/components/tailwind/_dynamic_checkbox.html.erb):
//   <div data-controller="dynamic-checkbox"
//        data-dynamic-checkbox-url-value="/form/forms/123/toggle_active"
//        data-dynamic-checkbox-method-value="PATCH">
//     <input type="checkbox" data-action="change->dynamic-checkbox#toggle">
//     <label>...</label>
//     <span class="intum-field-status w-4 h-4"></span>
//   </div>

const SPINNER_SVG = "<svg class=\"animate-spin h-4 w-4 text-gray-400\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z\"></path></svg>"
const CHECK_SVG = "<svg class=\"h-4 w-4 text-green-700\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z\" clip-rule=\"evenodd\"/></svg>"
const ERROR_SVG = "<svg class=\"h-4 w-4 text-red-700\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"currentColor\"><path fill-rule=\"evenodd\" d=\"M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z\" clip-rule=\"evenodd\"/></svg>"

export default class extends Controller {
  static values = { url: String, method: { type: String, default: "PATCH" } }

  toggle(event) {
    const checked = event.target.checked
    const csrfToken = document.querySelector("meta[name=csrf-token]")
    const spinner = this.element.querySelector(".intum-field-status")

    if (spinner) spinner.innerHTML = SPINNER_SVG

    fetch(this.urlValue, {
      method: this.methodValue,
      headers: {
        "X-CSRF-Token": csrfToken && csrfToken.content,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ value: checked }),
    }).then((response) => {
      if (!response.ok) throw new Error(response.status)
      if (spinner) spinner.innerHTML = CHECK_SVG
    }).catch(() => {
      // zapis się nie powiódł — cofnij stan checkboxa i zasygnalizuj błąd
      event.target.checked = !checked
      if (spinner) spinner.innerHTML = ERROR_SVG
    })
  }
}
